import { SITE_URL } from "@/utils/constants"
import Head from "next/head"
import { useRouter } from "next/router"

export interface SeoData {
  title: string
  description: string
  url?: string
  thumbnailUrl?: string
}

export interface SeoProps {
  data: SeoData
}

const Seo = ({ data }: SeoProps) => {
  const { title, description, url, thumbnailUrl } = data
  const { locale } = useRouter()
  const siteUrl = SITE_URL
  const appName = process.env.NEXT_PUBLIC_APP_NAME || "relend"
  const thumbnail = thumbnailUrl || `${siteUrl}/thumbnail-${appName}-${locale}.png`

  return (
    <div>
      <Head>
        {/* <!-- Primary Meta Tags --> */}
        <title>{title}</title>
        <meta name='title' content={title} />
        <meta name='description' content={description} />

        {/* <!-- Open Graph / Facebook --> */}
        <meta property='og:type' content='website' />
        <meta property='og:url' content={url} />
        <meta property='og:title' content={title} />
        <meta property='og:description' content={description} />
        <meta property='og:image' content={thumbnail} />

        {/* <!-- Twitter --> */}
        <meta property='twitter:card' content='summary_large_image' />
        <meta property='twitter:url' content={url} />
        <meta property='twitter:title' content={title} />
        <meta property='twitter:description' content={description} />
        <meta property='twitter:image' content={thumbnail} />
      </Head>
      <h1
        data-test-id='h1-seo-description'
        style={{
          display: "none",
        }}
      >
        {description}
      </h1>
    </div>
  )
}

export default Seo
